import RowSteps from '@/components/stepper/RowSteps';
import { Icon } from '@iconify/react';
import { Button } from '@nextui-org/react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

// Types
interface UserFormData {
  firstName: string;
  lastName: string;
  email: string;
  tenant: string;
  permissions: string[];
}

const defaultPermissions = [
  { id: 'view_dashboard', label: 'View Dashboard' },
  { id: 'manage_users', label: 'Manage Users' },
  { id: 'view_reports', label: 'View Reports' },
];

const steps = [{ title: 'Basic Details' }, { title: 'Permissions' }];

export default function CreateUser() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UserFormData>({
    defaultValues: {
      permissions: [],
    },
  });

  const onSubmit = (data: UserFormData) => {
    console.log(data);
    // Handle form submission
  };

  const renderBasicDetails = () => (
    <div className="space-y-4 ">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">First Name</label>
          <input
            {...register('firstName', { required: 'First name is required' })}
            className="w-full rounded-md border p-2"
          />
          {errors.firstName && (
            <span className="text-red-500 text-sm">
              {errors.firstName.message}
            </span>
          )}
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Last Name</label>
          <input
            {...register('lastName', { required: 'Last name is required' })}
            className="w-full rounded-md border p-2"
          />
          {errors.lastName && (
            <span className="text-red-500 text-sm">
              {errors.lastName.message}
            </span>
          )}
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">Email</label>
        <input
          {...register('email', {
            required: 'Email is required',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Invalid email address',
            },
          })}
          className="w-full rounded-md border p-2"
        />
        {errors.email && (
          <span className="text-red-500 text-sm">{errors.email.message}</span>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">Tenant</label>
        <input
          {...register('tenant', { required: 'Tenant is required' })}
          className="w-full rounded-md border p-2"
        />
        {errors.tenant && (
          <span className="text-red-500 text-sm">{errors.tenant.message}</span>
        )}
      </div>
    </div>
  );

  const renderPermissions = () => (
    <div className="space-y-4">
      {/* <h3 className="text-lg font-medium">User Permissions</h3> */}
      <div className="space-y-2">
        {defaultPermissions.map((permission) => (
          <div key={permission.id} className="flex items-center">
            <input
              type="checkbox"
              {...register('permissions')}
              value={permission.id}
              id={permission.id}
              className="mr-2"
            />
            <label htmlFor={permission.id}>{permission.label}</label>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="p-6">
      <div className="mb-6 flex items-center">
        <Button
          variant="light"
          onClick={() => navigate('/users')}
          className="mr-4"
        >
          <Icon icon="lucide:chevron-left" className="h-5 w-5" />
        </Button>
        <h1 className="text-2xl font-bold">Create User</h1>
      </div>

      <div className="flex flex-col align-center">
        <div className="flex  mb-8">
          <div className="w-3/5">
            <RowSteps
              steps={steps}
              currentStep={currentStep}
              onStepChange={setCurrentStep}
            />
          </div>
        </div>

        <div className="flex justify-start">
          <form onSubmit={handleSubmit(onSubmit)} className=" space-y-6 gap-4">
            {currentStep === 0 ? renderBasicDetails() : renderPermissions()}

            <div className="flex justify-end mt-6 gap-4">
              {currentStep > 0 && (
                <Button
                  variant="bordered"
                  onClick={() => setCurrentStep(currentStep - 1)}
                >
                  Previous
                </Button>
              )}
              {currentStep < steps.length - 1 ? (
                <Button
                  color="primary"
                  onClick={() => setCurrentStep(currentStep + 1)}
                >
                  Next
                </Button>
              ) : (
                <Button color="primary" type="submit">
                  Create User
                </Button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
